export const RTC_FEATURE_KEYS = {
    groupCalls: 'matrix-group-calls',
    videoCalls: 'matrix-video-calls',
    screenShare: 'matrix-screen-share',
} as const;

export interface RtcFeatureFlags {
    readonly groupCalls: boolean;
    readonly videoCalls: boolean;
    readonly screenShare: boolean;
}

export const NO_RTC_FEATURES: RtcFeatureFlags = {groupCalls: false, videoCalls: false, screenShare: false};

export interface TenantFeature {
    readonly feature: string;
    readonly enabled: boolean;
}

export const isRtcRuntimeEnabled = (env: {MATRIX_RTC_ENABLED?: string} | undefined): boolean =>
    env?.MATRIX_RTC_ENABLED === 'true';

export const resolveRtcFeatures = (
    features: readonly TenantFeature[] | undefined,
    runtimeEnabled: boolean,
): RtcFeatureFlags => {
    const enabled = (key: string) => features?.some(feature => feature.feature === key && feature.enabled) === true;
    return {
        groupCalls: runtimeEnabled && enabled(RTC_FEATURE_KEYS.groupCalls),
        videoCalls: enabled(RTC_FEATURE_KEYS.videoCalls),
        screenShare: enabled(RTC_FEATURE_KEYS.screenShare),
    };
};
